// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__NI6aD","btnRed":"styles_btnRed__i4Ef5","form":"styles_form__3-iWB"};